// extracted by mini-css-extract-plugin
export var radioInputRow = "x_sV";
export var radioInputColumn = "x_sW";
export var inputOptionRow = "x_qq";
export var inputOptionColumn = "x_qr";